import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import EditIcon from '@mui/icons-material/BorderColorOutlined';
import RadioButtonUncheckedOutlinedIcon from '@mui/icons-material/RadioButtonUncheckedOutlined';
import { Button, Chip, Grid, IconButton, SvgIcon, Typography } from '@mui/material';
import { blueGrey, grey } from '@mui/material/colors';
import { makeStyles } from '@mui/styles';
import arrayMove from 'array-move';
import clsx from 'clsx';
// import { useSnackbar } from "notistack";
import React from 'react';
import Gallery from 'react-photo-gallery';
import { SortableContainer, SortableElement, sortableHandle } from 'react-sortable-hoc';

// import { DataAPIContext } from "../api";
// import { selectSettings } from "../store/auth";

const useStyles = makeStyles((theme) => ({
    gallery: {
        height: '600px',
        // overflowY: "scroll"
    },
    root: {
        position: 'relative',
    },
    selectedRoot: {
        backgroundColor: grey[200],
        borderRadius: '20px',
        // borderWidth: '5px',
        // borderStyle: 'solid',
        // borderColor: theme.palette.primary.mainn,
    },
    uploadingRoot: {
        backgroundColor: blueGrey[400],
        borderRadius: '20px',
        opacity: 0.5,
    },
    selectBt: {
        position: 'absolute',
        bottom: theme.spacing(6),
        left: theme.spacing(28),

        color: '#ffffff',
    },
    unselectBt: {
        position: 'absolute',
        left: theme.spacing(28),
        bottom: theme.spacing(6),
    },
    chip: {
        position: 'absolute',
        left: theme.spacing(7),
        top: theme.spacing(2),
        zIndex: 1,
    },
    dragIndicator: {
        position: 'absolute',
        left: theme.spacing(-1),
        bottom: theme.spacing(2),
        color: '#ffffff',
        cursor: 'pointer',
    },
    editIcon: {
        display: 'none',
    },
    image: {
        width: 175,
        height: 175,
        borderRadius: '20px',
        margin: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            width: 115,
            height: 115,
        },
    },
    uploadingImage: {
        opacity: 0.7,
    },
    detailsImage: {
        borderRadius: '20px',
        height: '250px',
        backgroundSize: 'cover',
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    buttonWrapper: {
        position: 'relative',
        width: 175,
        height: 175,
        borderRadius: '20px',
        margin: theme.spacing(1),
    },
    uploadProgressIcon: {
        position: 'absolute',
        left: 70,
        top: 70,
    },
}));

const Checkmark = () => {
    return (
        <SvgIcon viewBox="0 0 32 32" fill="none" width="32" height="32">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z" fill="#007AFF" stroke="white" stroke-width="2" />
            <path d="M7.81836 16.6819L12.5911 21.4546L23.5002 10.5455" stroke="white" stroke-width="2" stroke-linecap="round" stroke-line-join="round" fill="#007AFF" />
        </SvgIcon>
    );
};

const ImageDragHandle = sortableHandle((props) => (
    <IconButton {...props}>
        <DragIndicatorIcon />
    </IconButton>
));

const GalleryImage = (props) => {
    const classes = useStyles();
    return (
        <div className={clsx(classes.root, props.isActive && classes.selectedRoot)} style={{ zIndex: 100000 }}>
            {props.showSelectBt ? (
                <IconButton className={props.isSelected ? classes.unselectBt : classes.selectBt} onClick={props.onSelectBtClick}>
                    {props.isSelected ? <Checkmark color="primary" /> : <RadioButtonUncheckedOutlinedIcon />}
                </IconButton>
            ) : null}
            {props.chip ? <Chip className={classes.chip} label={props.chip} /> : null}
            <img {...props.imageProps} onClick={props.isSmallScreen ? null : props.onClick} alt="img" className={classes.image} />
            <ImageDragHandle className={classes.dragIndicator} />
            {props.isSmallScreen ? (
                <IconButton className={classes.editIcon} onClick={props.onClick}>
                    <EditIcon color="primary" fontSize="small" />
                </IconButton>
            ) : null}
        </div>
    );
};

const GalleryItem = (props) => {
    // { index, onClick, photo, margin, direction, top, left, selected }
    // const [isSelected, setIsSelected] = React.useState(props.selected);
    // const imgStyle = { margin: margin };
    // if (direction === "column") {
    //     imgStyle.position = "absolute";
    //     imgStyle.left = left;
    //     imgStyle.top = top;
    // }
    const handleSelectBtClick = (ev) => {
        // const newIsSelected = !props.selected;
        // setIsSelected(newIsSelected);
        props.onSelect && props.onSelect(props, !props.selected);
    };

    const handleClick = (ev) => {
        console.log('photo click', ev, props);
        props.onClick && props.onClick(props, ev);
    };

    const chip = props.idx === 0 ? 'Cover' : null;
    const showSelectBt = props.selectable;
    console.log('image selectable', props.selectable, props);

    const { onClick: defOnClick, ...photoProps } = props.photo;

    // const isActive = props.activeImage && props.activeImage.id === photoProps.id;

    // console.log('Photo', isActive, props);

    return (
        <GalleryImage
            // isActive={isActive}
            showSelectBt={showSelectBt}
            isSelected={props.selected}
            onSelectBtClick={handleSelectBtClick}
            onClick={handleClick}
            chip={chip}
            imageProps={photoProps}
            isSmallScreen={props.isSmallScreen}
        />
    );
};

const SortableImage = SortableElement((item) => {
    // console.log('SortableImage', item);
    return <GalleryItem {...item} />;
});
const SortableGallery = SortableContainer(({ items, onImageClick, onSelect, activeImage, isSmallScreen, selectable }) => (
    <Gallery
        photos={items}
        renderImage={(props) => {
            console.log('photo', props, activeImage);
            return <SortableImage idx={props.index} {...props} selected={props.photo.selected} selectable={selectable} activeImage={activeImage} onClick={onImageClick} onSelect={onSelect} isSmallScreen={isSmallScreen} />;
        }}
    />
));

const ImageGalleryViewer = (props) => {
    // const dataAPI = React.useContext(DataAPIContext);
    const classes = useStyles();
    // const cellHeight = +props.cellHeight || 175;
    // const imgPreset = `cover_${cellHeight}x${cellHeight}`;
    // const [activeImage, setActiveImage] = React.useState(null);
    const activeImage = null;
    // const [selected, setSelected] = React.useState({});
    // const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const onSortEnd = ({ oldIndex, newIndex }) => {
        props.onChange && props.onChange(arrayMove(props.list, oldIndex, newIndex));
    };

    const onSelect = (item, checked) => {
        console.log('onSelect', item.photo.src, 'is', checked ? 'selected' : 'unselected');
        props.onChange && props.onChange(props.list.map((x, idx) => (item.idx === idx ? { ...x, selected: checked } : x)));
    };

    const onSelectAll = () => {
        props.onChange && props.onChange(props.list.map((x) => ({ ...x, selected: true })));
    };
    const onSelectNone = () => {
        props.onChange && props.onChange(props.list.map((x) => ({ ...x, selected: false })));
    };

    const cols = props.isSmallScreen ? (activeImage ? 0 : 12) : activeImage ? 8 : 12;

    console.log('ImageGalleryViewer', props.list);
    return (
        <Grid container direction="row">
            <Grid item xs={cols} container direction="row" spacing={2}>
                {props.isSmallScreen ? null : (
                    <Grid item xs={6}>
                        <Typography variant="body2">You can sort images by simply dragging and dropping them.</Typography>
                    </Grid>
                )}
                {props.selectable ? (
                    <Grid item xs={props.isSmallScreen ? 12 : 6} container justifyContent="flex-end">
                        <Button size="small" color="primary" onClick={onSelectAll}>
                            Select all
                        </Button>
                        <Button size="small" color="primary" onClick={onSelectNone}>
                            Select none
                        </Button>
                    </Grid>
                ) : null}
            </Grid>
            <Grid item xs={cols} className={classes.gallery} style={{ height: `${props.height || 600}px` }}>
                <SortableGallery
                    items={props.list}
                    selectable={props.selectable}
                    onSortEnd={onSortEnd}
                    onSelect={onSelect}
                    // onImageClick={onImageClick}
                    // activeImage={activeImage}
                    axis={'xy'}
                    useDragHandle
                    isSmallScreen={props.isSmallScreen}
                />
            </Grid>
        </Grid>
    );
};

export default ImageGalleryViewer;
